module.exports = __webpack_public_path__ + "assets/ic_kakao.7f1cc672.svg";